import { render, staticRenderFns } from "./PrimaryPalette.vue?vue&type=template&id=27e14e27&scoped=true"
import script from "./PrimaryPalette.vue?vue&type=script&lang=js"
export * from "./PrimaryPalette.vue?vue&type=script&lang=js"
import style0 from "./PrimaryPalette.vue?vue&type=style&index=0&id=27e14e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e14e27",
  null
  
)

export default component.exports